import { normalizeVin } from '@shared/validators';

/**
 * True when the secondary VIN matches the authenticated primary VIN.
 * Auth may store a full 17-character VIN or the last 7–8 characters from lookup.
 */
export function isSameAsPrimaryVin(secondaryVin: string, authPrimaryVin: string): boolean {
  const secondary = normalizeVin(secondaryVin);
  const primary = normalizeVin(authPrimaryVin);

  if (!secondary || !primary) {
    return false;
  }

  if (secondary === primary) {
    return true;
  }

  if (primary.length <= 8 && secondary.length === 17 && secondary.endsWith(primary)) {
    return true;
  }

  return false;
}
